var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{popup: _vm.$root.popUpShown},attrs:{"id":"app"}},[_c('Hero'),_c('main',[_c('router-view')],1),_c('Footer'),_c('Popup'),_c('CartStatus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }